import blogImage1 from "../../../Images/blogImage1.jpg"
import blogImage2 from "../../../Images/blogImage2.jpg"
import blogImage3 from "../../../Images/blogImage3.jpg"
import blogImage4 from "../../../Images/blogImage4.jpg"
import blogImage from "../../../Images/blogImage.png"
import blogImage5 from "../../../Images/blogImage5.jpg"
import blogImage6 from "../../../Images/blogImage6.jpg"
import blogImage7 from "../../../Images/blogImage7.jpg"
import blogImage8 from "../../../Images/blogImage8.jpg"

const blogsData = [
 {
  title: "What is Adhyayi? Complete Guide to Learning, Practice, Competition & Rewards",

  slug: "what-is-adhyayi-complete-guide",

  summary:
    "Discover Adhyayi, a complete learning ecosystem for SSC, Banking, Railway, UPSC, Police, Teaching, Forest and other competitive exam aspirants. Learn, practice, compete, track performance and unlock reward opportunities through a smart Learning With Earning approach.",

  authorName: "Adhyayi Team",

  category: "Adhyayi",

  tags: [
    "Adhyayi",
    "Learning With Earning",
    "Competitive Exams",
    "SSC Preparation",
    "Banking Exams",
    "Railway Exams",
    "UPSC",
    "Mock Tests",
    "Quiz Platform",
    "Performance Tracking",
    "Government Exams",
    "Student Rewards",
  ],

  featuredImage: blogImage,

  galleryImages: [
    blogImage2,
    blogImage3
  ],

  status: "published",

  isFeatured: true,

  isTrending: true,

  publishedAt: new Date(),

  readingTime: 12,

  content: [
    {
      heading: "Introduction",
      content:
        "Every year, millions of students prepare for competitive exams such as SSC, Banking, Railway, UPSC, Police, Teaching and various State Government examinations. Most students start their preparation with enthusiasm and high expectations. However, after a few weeks or months, many begin to lose consistency, motivation and focus.One of the biggest reasons behind this problem is that traditional learning methods often lack engagement, competition and measurable progress. Students study for hours but have no clear way to evaluate their performance, compare their progress with others or stay motivated throughout their journey.This is where Adhyayi introduces a new approach.Adhyayi is not just another learning platform. It is a complete ecosystem designed to combine learning, practice, competition, performance tracking and rewards into one unified experience. The goal is to make exam preparation more engaging, measurable, competitive and rewarding.",
      order: 1,
    },
    {
      heading: "Learning With Earning",
      content:
        "Students do not simply consume content. They learn concepts, practice regularly, participate in challenges, track their progress, improve their skills and unlock reward opportunities based on their performance.",
      order: 2,
    },

    {
      heading: "What is Adhyayi?",
      content:
        "Adhyayi is a Smart Learning + Earning platform designed specifically for competitive exam aspirants. Unlike traditional learning apps that focus only on content delivery, Adhyayi creates a complete preparation journey where students can learn concepts, practice regularly, participate in contests, monitor performance and unlock reward opportunities through achievements.",
      order: 3,
    },

    {
      heading: "Structured Learning Path",
      content:
        "Students can follow a guided roadmap instead of randomly switching between resources.Benefits include:Organized study flow Better concept understanding Reduced confusion Improved preparation efficiency",
      order: 4,
    },

    {
      heading: "The Four Pillars of Adhyayi",
      content:
        "The Adhyayi ecosystem revolves around four core pillars: Learn, Practice, Compete and Earn. Students gain knowledge through structured courses, strengthen concepts through quizzes and mock tests, compete with other aspirants in contests and receive opportunities for rewards based on performance.",
        bulletPoints:`. Learn

Students gain knowledge through structured courses and learning resources.

2. Practice

Students improve through quizzes, mock tests and topic-wise assessments.

3. Compete

Students participate in contests and compare their performance with others.

4. Earn

Students receive opportunities for rewards based on their performance and achievements.`,
      order: 5,
    },

    {
      heading: "Courses & Structured Learning",
      content:
        "Adhyayi provides organized educational content tailored for competitive exams. Students can follow structured learning paths instead of jumping between multiple resources. Topic-wise and subject-wise preparation helps learners focus on concepts such as Mathematics, Reasoning, English, General Knowledge, Current Affairs and General Science in a systematic manner.",
        bulletPoints:`Benefits include:

Organized study flow
Better concept understanding
Reduced confusion
Improved preparation efficiency
Subject-Wise Learning

Students can prepare individual subjects according to their strengths and weaknesses.

Subjects may include:

Mathematics
Reasoning
English
General Knowledge
General Science
Current Affairs`,
      order: 6,
    },

    {
      heading: "Quiz & Practice System",
      content:
        "Regular practice is essential for exam success. Adhyayi offers daily quizzes, topic-wise quizzes, subject-wise assessments and mock tests. These practice modules help students revise concepts, strengthen weak areas, improve accuracy and build confidence while simulating real exam conditions.",
        bulletPoints:`Daily quizzes help students:

Revise concepts regularly
Build consistency
Improve retention
Develop exam habits
Subject-Wise Practice

Students can focus practice sessions on specific subjects.

This helps:

Strengthen weak areas
Improve accuracy
Build confidence
Mock Tests

Mock tests simulate real examination environments.

Benefits include:

Time management improvement
Exam pressure handling
Performance evaluation
Readiness assessment`,
      order: 7,
    },

    {
      heading: "Contest Ecosystem",
      content:
        "Competition is one of the strongest motivators for learning. Adhyayi provides skill-based contests where students compete based on preparation and performance rather than luck. Leaderboards and rankings allow aspirants to compare their progress, stay motivated and continuously improve.",
        bulletPoints:`Competitive Learning Environment

When students compete with others:

Motivation increases
Focus improves
Preparation becomes more serious
Learning becomes engaging
Leaderboards & Rankings

Students can view:

Rank Position
Contest Performance
Relative Standing
`,
      order: 8,
    },

    {
      heading: "Performance Tracking & Analytics",
      content:
        "Adhyayi helps students understand where they stand through detailed analytics. Users can track accuracy, rank positions, learning progress, practice consistency, strengths, weaknesses and time management. These insights help students make smarter preparation strategies and measure real improvement.",
        bulletPoints:`Accuracy Analysis

Students can track:

Correct Answers
Incorrect Answers
Accuracy Percentage
Rank Tracking

Students can monitor:

Current Rank
Historical Performance
Ranking Improvements
Progress Reports

Detailed reports allow students to understand:

Learning progress
Practice consistency
Subject performance
Overall development
Strength & Weakness Analysis

Students can identify:

Strong subjects
Weak subjects
Improvement areas

This allows smarter study planning.

Time-Based Performance Monitoring

Students can evaluate:

Speed
Time Management
Efficiency`,
      order: 9,
    },

    {
      heading: "Performance-Based Rewards",
      content:
        "One of the most unique features of Adhyayi is its reward-oriented ecosystem. Rewards are linked to measurable performance indicators such as rankings, accuracy, participation, contest results and consistency. The platform focuses on genuine effort and achievement rather than random outcomes.",
        bulletPoints:`No Luck. Only Performance.

Unlike systems that depend on random outcomes, Adhyayi focuses on measurable performance.

Rewards are connected to:

Rankings
Accuracy
Contest Results
Participation
Consistency`,
      order: 10,
    },

    {
      heading: "Why Adhyayi is Different",
      content:
        "Traditional learning apps usually provide only content. Adhyayi goes beyond learning by integrating practice, competition, rankings, performance tracking, engagement and rewards into a single platform. This creates a more motivating and measurable learning experience for aspirants.",
        bulletPoints:`Traditional Learning Apps
Only provide content
Limited engagement
Minimal competition
Little performance visibility
Lower student motivation
Adhyayi
Learning
Practice
Competition
Performance tracking`,
      order: 11,
    },

    {
      heading: "Future Vision",
      content:
        "Adhyayi aims to transform exam preparation into a more engaging, measurable and rewarding journey. Future goals include expanding exam coverage, introducing advanced analytics, improving student engagement and providing even more opportunities for learners to grow and succeed.",
      order: 12,
    },

    {
      heading: "Conclusion",
      content:
        "Competitive exam preparation requires more than just studying. Students need consistency, practice, motivation and continuous performance evaluation. Adhyayi brings all these elements together through its Learning With Earning ecosystem, helping aspirants learn smarter, practice consistently, compete confidently and grow through performance.",
      order: 13,
    },
  ],
},

  {
    title: "Learning With Earning – The Future of Student Success",
    slug: "learning-with-earning-future-of-student-success",

    summary:
      "Discover how Learning With Earning helps students stay motivated, improve performance and build a consistent study routine.",

    authorName: "Adhyayi Team",

    category: "Learning With Earning",

    tags: [
      "Learning With Earning",
      "Student Success",
      "Rewards",
      "Motivation",
      "Competitive Exams",
    ],

    featuredImage:
     blogImage8,

    galleryImages: [],

    status: "published",

    isFeatured: true,

    isTrending: true,

    publishedAt: new Date(),

    readingTime: 10,

    content: [
      {
        heading: "Why Students Lose Motivation",
        content:
          "Many students struggle to maintain consistency because they do not see measurable progress in their preparation journey.",
        order: 1,
      },
      {
        heading: "What is Learning With Earning?",
        content:
          "Learning With Earning encourages students to improve performance while gaining opportunities for rewards and recognition.",
        order: 2,
      },
      {
        heading: "Benefits",
        content:
          "Improved engagement, daily practice habits, motivation and better exam readiness.",
        order: 3,
      },
    ],
  },

  {
    title:
      "Why Performance Tracking Matters in Competitive Exam Preparation",

    slug: "why-performance-tracking-matters",

    summary:
      "Understand how rank tracking, accuracy analysis and progress monitoring can improve your exam preparation.",

    authorName: "Adhyayi Team",

    category: "Performance Tracking",

    tags: [
      "Performance Tracking",
      "Accuracy Analysis",
      "Rank Tracking",
      "Exam Analytics",
    ],

    featuredImage:
     blogImage5,

    galleryImages: [],

    status: "published",

    isFeatured: false,

    isTrending: true,

    publishedAt: new Date(),

    readingTime: 8,

    content: [
      {
        heading: "Importance of Analytics",
        content:
          "Without data, students cannot accurately measure strengths, weaknesses and progress.",
        order: 1,
      },
      {
        heading: "Key Metrics",
        content:
          "Accuracy percentage, rank position, time management and subject-wise performance.",
        order: 2,
      },
      {
        heading: "How Adhyayi Helps",
        content:
          "Advanced performance reports help students prepare smarter and improve continuously.",
        order: 3,
      },
    ],
  },

  {
    title:
      "How Adhyayi Contests Work: Skill-Based Competitive Learning Explained",

    slug: "how-adhyayi-contests-work",

    summary:
      "Learn how Adhyayi contests create a competitive environment where students can test skills and improve rankings.",

    authorName: "Adhyayi Team",

    category: "Contests",

    tags: [
      "Contest",
      "Competition",
      "Leaderboards",
      "Rankings",
      "Skill Based Learning",
    ],

    featuredImage:
      blogImage6,

    galleryImages: [],

    status: "published",

    isFeatured: false,

    isTrending: true,

    publishedAt: new Date(),

    readingTime: 9,

    content: [
      {
        heading: "Contest Overview",
        content:
          "Students participate in skill-based contests designed to test knowledge and preparation levels.",
        order: 1,
      },
      {
        heading: "Ranking System",
        content:
          "Performance determines rankings and leaderboard positions.",
        order: 2,
      },
      {
        heading: "Rewards",
        content:
          "High-performing students receive opportunities for rewards and recognition.",
        order: 3,
      },
    ],
  },

  {
    title:
      "Learn → Practice → Compete → Improve → Earn: The Complete Adhyayi Journey",

    slug: "complete-adhyayi-journey",

    summary:
      "Explore the complete student journey on Adhyayi from learning concepts to earning rewards.",

    authorName: "Adhyayi Team",

    category: "Student Journey",

    tags: [
      "Adhyayi Journey",
      "Learn Practice Compete Earn",
      "Student Growth",
      "Competitive Learning",
    ],

    featuredImage:
      blogImage7,

    galleryImages: [],

    status: "published",

    isFeatured: true,

    isTrending: true,

    publishedAt: new Date(),

    readingTime: 11,

    content: [
      {
        heading: "Step 1 - Learn",
        content:
          "Study concepts through structured learning resources and courses.",
        order: 1,
      },
      {
        heading: "Step 2 - Practice",
        content:
          "Attempt quizzes and mock tests to improve understanding.",
        order: 2,
      },
      {
        heading: "Step 3 - Compete",
        content:
          "Participate in contests and challenge other aspirants.",
        order: 3,
      },
      {
        heading: "Step 4 - Improve",
        content:
          "Track performance and identify weak areas for improvement.",
        order: 4,
      },
      {
        heading: "Step 5 - Earn",
        content:
          "Unlock reward opportunities through consistent performance.",
        order: 5,
      },
    ],
  },
];

export default blogsData;